import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { icon } from '@fortawesome/fontawesome-svg-core';
import $ from 'jquery';
import 'jquery-hoverintent';

$(document).ready(function() {
  const nodes = document.querySelectorAll('#primary_nav > ul > li.mega-menu-label > a');
  if (nodes.length > 0) {
    const iconNode = icon(faAngleDown).node[0];
    for (let i = 0, len = nodes.length; i < len; i++) {
      nodes[i].appendChild(iconNode.cloneNode(true));
    }
  }

  $("#navbar ul.nav > li").hoverIntent({
    timeout: 250,
    over: function() {
      $(this).addClass("mega-menu-show");
    },
    out: function() {
      $(this).removeClass("mega-menu-show");
    }
  });

  $("nav.navbar").hoverIntent({
    timeout: 250,
    over: function() {
      $(this).addClass("mega-menu-expanded");
    },
    out: function() {
      $(this).removeClass("mega-menu-expanded");
    }
  });
});
